import { FC, useState } from 'react';
import { Auth } from '@aws-amplify/auth';
import Button from 'antd/lib/button/button';
import Divider from 'antd/lib/divider';
import Form from 'antd/lib/form/Form';

import ChangePasswordForm from 'components/ChangePassword/ChangePasswordForm';
import ChangePasswordSuccess from 'components/ChangePassword/ChangePasswordSuccess';
import MessageWrapper from 'components/MessageWrapper/MessageWrapper';
import { IModalProps } from 'components/Modal/constants';
import { ErrorIcn } from 'utils/icons';

const headerTextByStep = [<h2 key="header" className="my-4">Change Password</h2>, null];
const buttonTextByStep = ['Change Password', 'Done'];
const steps = [ChangePasswordForm, ChangePasswordSuccess];

const ChangePassword: FC<IModalProps> = ({ onModalClose }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [step, setStep] = useState<0 | 1>(0);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const StepComponent = steps[step];

  const handleSubmit = async({ oldPassword, newPassword }: any) => {
    if (step === 1) {
      return onModalClose();
    }

    setIsLoading(true);
    try {
      const user = await Auth.currentAuthenticatedUser();

      await Auth.changePassword(user, oldPassword, newPassword);
      setStep(1);
      setErrorMessage('');
    } catch ({ code, message }) {
      setErrorMessage(code === 'NotAuthorizedException' ? 'Incorrect Old Password' : message as string);
    }
    setIsLoading(false);
  };

  return (
    <>
      {headerTextByStep[step]}
      <MessageWrapper isVisible={!!errorMessage} className="mb-5 text-red-50 bg-red-50/20">
        <ErrorIcn className="min-w-[24px]" />{errorMessage}
      </MessageWrapper>
      <Form layout="vertical" validateTrigger="onSubmit" className="w-96" onFinish={handleSubmit}>
        <StepComponent />
        <Divider />
        <Button loading={isLoading} type="primary" htmlType="submit" size="large" className="block ml-auto">
          {buttonTextByStep[step]}
        </Button>
      </Form>
    </>
  );
};

export default ChangePassword;
